import { API } from './API.js';
import axios from 'axios';

const url = API + '/entries/';
const debug = false;

class Entries {
    static get() {
        return new Promise ( async (resolve, reject) => {
            try {
                const res = await axios.get(url);
                const data = res.data;
                resolve(
                    data.map(winery=> ({
                        ...winery,
                        name: winery.name
                    }))
                );
                if (debug) console.log("Entries.get: data = ", data)
            } catch(err) {
                reject(err);
            }
        })
    }

    // get one winery
    static getone(id) {
        return axios.get(`${url}${id}`)
            .then(response => {
                if (debug) console.log('Entries.getone: ',response.data)
                return response.data
            })
            .catch(error => {
                console.log('Entries.getone: ',error)
            })
    }

    static create(postdata) {
        if (debug) console.log('Entries.create: postdata = ',postdata)
        return axios.post(url, postdata)
            .then(response => {
                if (debug) console.log('Entries.create: response = ',response)
                return response.data._id
            })
            .catch(error => {
                console.log('Entries.create: ',error)
            })
    }

    static update(id,postdata) {
        if (debug) console.log('Entries.update: id=',id)
        if (debug) console.log('Entries.update: postdata=',postdata)
        return axios.put(`${url}${id}`, postdata)
            .then(response => {
                if (debug) console.log('Entries.update: ',response)
                return id
            })
            .catch(error => {
                console.log('Entries.update: ',error)
            })
    }

    static delete(id) {
        return axios.delete(`${url}${id}`)
    } 
}

export default Entries